<script>
  /* FRAGMENTS - COMPONENTS */
  import Menu from "./fragments/menu.svelte";
  import Tagline from "./fragments/tagline.svelte";
  import Heading from "./fragments/heading.svelte";
  import Page from "./fragments/page.svelte";
  import SlideLogos from "./fragments/slidelogos.svelte";

  /* PAGES IMPORT */
  import PageOurMission from "./pages/ourmission.svelte";
  import PageWhatWeDo from "./pages/whatwedo.svelte";
  import PageOurActions from "./pages/ouractions.svelte";
  import PageReserved from "./pages/reserved.svelte";
  import PageTeam from "./pages/team.svelte";
  import SpecialPage from "./pages/regione-piu-grande.svelte";

  /* PAGES */
  let pages = [
    { title: "La nostra missione", page: PageOurMission, id: "" },
    { title: "Cosa Facciamo", page: PageWhatWeDo, id: "whatwedo" },
    { title: "Le nostre iniziative", page: PageOurActions, id: "ouractions" },
    {
      title: "Agricoltura di Precisione: in elaborazione",
      page: PageReserved,
      id: "wip1",
    },
    { title: "Aerospazio: in elaborazione", page: PageReserved, id: "wip2" },
    {
      title: "Economia Circolare: in elaborazione",
      page: PageReserved,
      id: "wip3",
    },
    { title: "Team", page: PageTeam, id: "team" },
  ];

  let route = "home";
  export let name;
</script>

{#if route == "home"}
  <Menu />
  <h1 class="text-xl text-center" text-center>Parco Scientifico e Tecnologico di Verona s.r.l.</h1>
  <Tagline />
  {#each pages as page}
    <Page title={page.title} id={page.id}>
      <svelte:component this={page.page} />
    </Page>
  {/each}
  <div class="footer-spacing" />
  <SlideLogos
    on:go-to-special-page={() => {
      route = "special";
    }}
  />
{:else}
 <div class="container back-button p-xl" on:click={() => { route = "home"}}>
    ⬅ Indietro
  </div>
  <SpecialPage />
{/if}

<style>
  * {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }
  :global(body, html) {
    margin: 0;
    padding: 0;
  }

  :global(body) {
    --green: #00b050;
    --yellow: #ffc000;
    --blue: #4472c4;
    --red: #ff0054;
    --black: #343434;
    --white: #ededed;
  }

  :global(.red) {
    color: var(--red);
  }

  :global(a, a:hover) {
    text-decoration: none;
  }

  :global([text-center]) {
    text-align: center;
  }

  :global(.mb-xxl) {
    margin-bottom: 3em;
  }

  :global(.mb-xl) {
    margin-bottom: 1.5em;
  }

  :global(.mt-xl) {
    margin-top: 1.5em;
  }

  :global(.bold) {
    font-weight: bold;
  }

  @media (max-width: 900px) {
    :global(body) {
      padding: 40px;
    }
  }
  h1 {
    color: var(--blue);
  }

  .back-button {
    font-weight: bold;
    font-size: 1.5em;
    cursor: pointer;
  }

  .footer-spacing {
    height: 20px;
  }

  :global(.mt-s) {
    margin-top: 5px;
  }
  :global(.mr-s) {
    margin-right: 5px;
  }
  :global(.mb-s) {
    margin-bottom: 5px;
  }
  :global(.ml-s) {
    margin-left: 5px;
  }

  :global(.mt-m) {
    margin-top: 10px;
  }
  :global(.mr-m) {
    margin-right: 10px;
  }
  :global(.mb-m) {
    margin-bottom: 10px;
  }
  :global(.ml-m) {
    margin-left: 10px;
  }

  :global(.mt-l) {
    margin-top: 15px;
  }
  :global(.mr-l) {
    margin-right: 15px;
  }
  :global(.mb-l) {
    margin-bottom: 15px;
  }
  :global(.ml-l) {
    margin-left: 15px;
  }

  :global(.pt-s) {
    padding-top: 5px;
  }
  :global(.pr-s) {
    padding-right: 5px;
  }
  :global(.pb-s) {
    padding-bottom: 5px;
  }
  :global(.pl-s) {
    padding-left: 5px;
  }

  :global(.pt-m) {
    padding-top: 10px;
  }
  :global(.pr-m) {
    padding-right: 10px;
  }
  :global(.pb-m) {
    padding-bottom: 10px;
  }
  :global(.pl-m) {
    padding-left: 10px;
  }

  :global(.pt-l) {
    padding-top: 15px;
  }
  :global(.pr-l) {
    padding-right: 15px;
  }
  :global(.pb-l) {
    padding-bottom: 15px;
  }
  :global(.pl-l) {
    padding-left: 15px;
  }

  :global(.m-s) {
    margin: 5px;
  }
  :global(.m-m) {
    margin: 10px;
  }
  :global(.m-l) {
    margin: 15px;
  }
  :global(.m-xl) {
    padding: 20px;
  }
  :global(.m-xxl) {
    padding: 25px;
  }

  :global(.p-s) {
    padding: 5px;
  }
  :global(.p-m) {
    padding: 10px;
  }
  :global(.p-l) {
    padding: 15px;
  }
  :global(.p-xl) {
    padding: 20px;
  }
  :global(.p-xxl) {
    padding: 25px;
  }
</style>
